import { CategoryGroupIds } from './../../../modules/shared/constants/category-groupid.constants';
import { HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SavedSearchNS } from '../models/saved-search.models';
import { IFeedbackModel, IInitializeModel, IQuestionModel } from '../../../modules/shared/components/chatbot-modal/model/chatbot.model';

@Injectable()
export class SavedSearchesService {

    workflowAPI: string;
    coreUrl: string;
    constructor(private http: HttpClient) {
        this.workflowAPI = environment.workflowAPI;
        this.coreUrl = environment.coreUrl;
    }

    //POST New saved search
    addSavedSearch(newSavedSearch: SavedSearchNS.NewSavedSearches) {
        return this.http.post<any>(`${this.workflowAPI}SavedSearch`, newSavedSearch);
    }

    //PUT Update saved search
    updateSavedSearch(updateSavedSearch: SavedSearchNS.UpdateSavedSearches) {
        return this.http.put<any>(`${this.workflowAPI}SavedSearch`, updateSavedSearch);
    }

    //Get Saved-Search List
    getAllSavedSearchList(pageNumber: number, pageSize: number, isActive: boolean, options?): Observable<any> {
        let url = `${this.workflowAPI}SavedSearch?PageNumber=${pageNumber}&PageSize=${pageSize}&isActive=${isActive}`;

        if (options) {
            if (options.sort) {
                url = `${url}&SortBy=${options.sort.SortBy}&IsAscending=${options.sort.IsAscending}`;
            }
            if (options.filter && options.filter.field) {
                url = `${url}&SearchValue=${options.filter.value}&SearchColumns=${options.filter.field}`;
            }
            if (options.moduleSearchValue) {
                url = `${url}&ModuleSearchValue=${encodeURIComponent(options.moduleSearchValue)}`;
            }
            if (options?.moduleId) {
                url = `${url}&moduleId=${options?.moduleId}`;
            }
            if (options?.channelId) {
                url = `${url}&channelId=${options?.channelId}`;
            }
        }

        // default sorting
        if (!options || !options.sort) {
            url = `${url}&SortBy=CreatedDate&IsAscending=false`;
        }

        return this.http.get<any>(url, {
            observe: 'response',
            headers: new HttpHeaders()
        });
    }
    //Saved-Search by Id
    getSavedSearchById(id: number) {
        return this.http.get<any>(`${this.workflowAPI}SavedSearch/${id}`);
    }

    //get module by name
    getSaveSearchObject(groupName: string, objectName: string) {
        return this.http.get<any>(`${this.coreUrl}Type/SaveSearchObject?groupName=${groupName}&objectName=${objectName}`);
    }

    //get savedsearch result
    getSavedSearchResult(pageNumber: number, pageSize: number, savedSearchId: number, filter: string, fromdate: string, todate: string, searchvalue: string, aggregatedBy: string = "", orderBy: string = "") {
        let url = `${this.workflowAPI}SavedSearch/Result?PageNumber=${pageNumber}&PageSize=${pageSize}&savedSearchId=${savedSearchId}&filter=${filter}&fromdate=${fromdate}&todate=${todate}&searchvalue=${searchvalue}`;

        if(aggregatedBy){
            url = `${url}&aggregatedBy=${encodeURIComponent(aggregatedBy)}`;
        }

        if(orderBy){
            url = `${url}&orderBy=${encodeURIComponent(orderBy)}`;
        }

        return this.http.get<any>(url, {
            observe: 'response',
            headers: new HttpHeaders()
        });
        // return this.http.get<any>(`${this.workflowAPI}SavedSearch/Result?savedSearchId=${savedSearchId}&filter=${filter}&fromdate=${fromdate}&todate=${todate}`);
    }

    getSavedSearchPostResults(queryData: SavedSearchNS.SavedSearchResultQuery){
        return this.http.post<any>(`${this.workflowAPI}SavedSearchResult`, queryData);
    }

    getSavedSearchPostGroupedResults(queryData: SavedSearchNS.SavedSearchGroupedResultQuery){
        return this.http.post<any>(`${this.workflowAPI}SavedSearchResult/Grouped`, queryData);
    }

    getSavedSearcFilterValues(queryData: SavedSearchNS.SavedSearchQueryFilters){
        return this.http.post<any>(`${this.workflowAPI}SavedSearchResult/Filter`, queryData);
    }

    getSavedSearchFilter(savedSearchId: number, columnname: string, fielddatatype: string, isCustom: boolean, filtervalue: any,isCommaSeperated?) {
        let url = `${this.workflowAPI}SavedSearch/Fewwdilter?saveSearchId=${savedSearchId}&columnname=${encodeURIComponent(columnname)}&fielddatatype=${fielddatatype}&isCustom=${isCustom}&filtervalue=${encodeURIComponent(filtervalue)}&IsCommaSeperatedAndNumber=${isCommaSeperated}`;
        return this.http.get<any>(url);
    }

    regenerateSavedSearcQuery(moduleId: number, savedSearchId: number){
        return this.http.post<any>(`${this.workflowAPI}SavedSearch/GenerateQuery/Module/${moduleId}/SavedSearch/${savedSearchId}`, null);
    }

    //Update Saved-Search Column Settings
    updateColumnSettings(columnSettignsObj: SavedSearchNS.IUpdateColumnSettings) {
        return this.http.put<any>(`${this.workflowAPI}SavedSearch/UpdateColumnSettings`, columnSettignsObj);
    }

    //Delete savedsearch
    deleteSavedSearch(savedSearchId: number) {
        return this.http.delete<any>(`${this.workflowAPI}SavedSearch/${savedSearchId}`);
    }

    getAllCountryDto() {
        return this.http.get<any>(`${environment.apiUrl}Country/CountryMinified`);
    }

    getStateByMultipleCountryIdDto(countryIds: string) {
        return this.http.get<any>(`${environment.apiUrl}State/StateByMultipleCountryId?countryIds=${countryIds}`);
    }

    getCitiesByMultipleStateId(stateIds: string) {
        return this.http.get<any>(`${environment.apiUrl}City/CitiesByMultipleStateId?stateIds=${stateIds}`);
    }

    /************** Estimate & Invoice **************/
    getAllWarehouse(searchValue: string = "") {
        return this.http.get<any>(`${environment.inventoryURl}WareHouse/WarehouseWithName?search=${searchValue}`);
    }

    getWarehouseFullList(pageNo: string = "0", pageSize: string = "0", isAscending: any = ""){
        let params = new HttpParams();
        params = !pageNo ? params : params.append("PageNumber", pageNo);
        params = !pageSize ? params : params.append("PageSize", pageSize);
        params = !isAscending
            ? params
            : params.append("IsAscending", isAscending);

        return this.http.get<any>(`${environment.inventoryURl}WareHouse/AllWarehouseDetails`, {params});
    }

    getInventoryGroups(id?) {
        let params = new HttpParams();
        params =  id ? params.append('parentGroupId', id): params;
        return this.http.get<any>(`${environment.inventoryURl}Group`, {params});
    }

    getAllTax(groupId) {
        return this.http.get<any>(`${environment.inventoryURl}Type?groupId=${groupId}`);
    }

    getDiscountTypes(groupId) {
        return this.http.get<any>(`${environment.inventoryURl}Type?groupId=${groupId}`);
    }

    getDiscounts(showShipping: boolean) {
        return this.http.get<any>(`${environment.inventoryURl}Discount?showShipping=${showShipping}`);
    }

    getAllList() {
        return this.http.get<any>(`${environment.inventoryURl}Tax`);
    }

    getInventoryCategory(id) {
        return this.http.get<any>(`${environment.inventoryURl}Category?groupId=${id}`);
    }

    getUOMByCategory(categoryId) {
        return this.http.get<any>(`${environment.inventoryURl}UOMDetail/UOMByCategory?categoryId=${categoryId}`);
    }

    getBrandList(): Observable<any> {
        return this.http.get<any>(`${environment.inventoryURl}Brand`);
    }

    getvendorsDD(searchValue: string = ""): Observable<any>{
        return this.http.get<any>(`${environment.inventoryURl}Vendor/AllVendorDetails?PageSize=0&PageNumber=0&SearchValue=${searchValue}`);
    }

    getConfigurationsByModule(name): Observable<any> {
        return this.http.get<any>(`${environment.configUrl}Configuration/ConfigurationsByModuleName?name=${name}`);
    }

    getAllDiscount() {
        return this.http.get<any>(`${environment.inventoryURl}Discount/DiscountConfiguration`);
    }

    getProductMinified() {
        return this.http.get<any>(`${environment.inventoryURl}Product/ProductMinified`);
    }

    getAccountList() {
        return this.http.get<any>(`${environment.apiUrlAccount + "Account/"}AccountsWithName`);
    }

    getOpportunitySources(orgId: number) {
        return this.http.get<any>(`${environment.configUrl}Source?organizationId=${orgId}`);
    }

    getOpportunityRatings(){
        return this.http.get<any>(environment.configUrl + 'Rating')
    }

    getForecastCategories() {
        return this.http.get<any>(`${environment.opportunityUrl}Category?groupId=${CategoryGroupIds.OpportunityForeCastCategory}`);
    }

    getAllModules(groupName: string){
        return this.http.get<any>(`${environment.coreUrl}Type/SaveSearchObjectAll?groupName=${groupName}`);
    }

    //Group By
    getGroupBySavedSearchResult(pageNumber: number, pageSize: number, savedSearchId: number, filter: string, fromdate: string, todate: string, searchvalue: string, groupBy: string) {
        let url = `${this.workflowAPI}SavedSearch/ResultGroupBy?PageNumber=${pageNumber}&PageSize=${pageSize}&savedSearchId=${savedSearchId}&filter=${filter}&fromdate=${fromdate}&todate=${todate}&searchvalue=${searchvalue}&groupBy=${encodeURIComponent(groupBy)}`;
        return this.http.get<any>(url, {
            observe: 'response',
            headers: new HttpHeaders()
        });
    }

    //save groupBy option
    saveGroupByOption(savedSearchId: number, groupBy: string) {
        let url = `${this.workflowAPI}SavedSearch/ResultUpdateGroupBy?savedSearchId=${savedSearchId}`;
        let payload = JSON.stringify(groupBy||""); // Convert payload to string
        return this.http.put<any>(url, payload, {
            headers: {
                'Content-Type': 'application/json' // Set content type to application/json
            }
        })
        .toPromise()
        .then(res => res);
    }

    getAllAutoCompleteData(channelId,type,searchValue): Observable<any[]> {
        let params = new HttpParams();
        params = searchValue ? params.append('search', searchValue): params;
        params = searchValue ? params.append('typeId', channelId): params;

        return this.http.get<any>(`${environment.inventoryURl}Product/InventorySavedSearchDropDownData?typename=${type}`, {params});
    }

    getOpportunityAutoCompleteData(searchValue,channelId): Observable<any[]> {
        return this.http.get<any>(`${environment.opportunityUrl}Opportunity/OpportunitysWithName?channelId=${channelId}&search=${searchValue}&isTerritory=false`);
    }

    getOpportunityNotesAutoCompleteData(searchValue,channelId): Observable<any[]> {
        return this.http.get<any>(`${environment.opportunityUrl}Opportunity/OpportunityNotes?channelId=${channelId}&search=${searchValue}`);
    }

    // chat
    initialize(initializationData: IInitializeModel) {
        return this.http.post<any>(`${this.workflowAPI}SavedSearchAnalytics/initialize`, initializationData);
    }
    getSampleQuestions(sessionId) {
        return this.http.get<any>(`${this.workflowAPI}SavedSearchAnalytics/samplequestions/${sessionId}`);
    }
    askQuestion(questionData: IQuestionModel) {
        return this.http.post<any>(`${this.workflowAPI}SavedSearchAnalytics/ask`, questionData);
    }
    saveFeedback(feedback: IFeedbackModel) {
        return this.http.post<any>(`${this.workflowAPI}SavedSearchAnalytics/userfeedback`, feedback);
    }

    saveSearchPredictionModel(feedback: {
        savedSearchId: number,
        targetColumn: string
    }) {
        return this.http.post<any>(`${this.workflowAPI}SavedSearchAnalytics/PredictionModel`, feedback);
    }

    saveSearchForecastingModel(feedback: {
        savedSearchId: number,
        targetColumn: string,
        dateColumn: string
    }) {
        return this.http.post<any>(`${this.workflowAPI}SavedSearchAnalytics/ForecastPredictionModel`, feedback);
    }

    saveSearchModelData(id: any): Observable<any> {
        return this.http.get<any>(`${this.workflowAPI}SavedSearchAnalytics/${id}`);
    }

    // export
    exportToCSV(id: number, cols: string) {
        return this.http.post<any>(`${this.workflowAPI}SavedSearch/ExportToCsv?id=${id}&SearchColumns=${encodeURIComponent(cols)}`, {});
    }

    exportSavedSearchResult(queryData: SavedSearchNS.SavedSearchExportQuery) {
        return this.http.post<any>(`${this.workflowAPI}SavedSearchResult/ExportToCsv`, queryData);
    }

    getAllTaskId(taskId:number, name:any){
        return this.http.get<any>(`${environment.activity}/LionO360/2.0/API/Task/IdList?taskIdType=${taskId}&searchValue=${name}`)
    }

    getAllTaskTitle(taskIdType: number, searchValue: string) {
        return this.http.get<any>(`${environment.activity}/LionO360/2.0/API/Task/IdList?taskIdType=${taskIdType}&searchValue=${searchValue}`);
    }

    PredictionModelMappingForSavedSearch(savedSearchId: number) : Observable<any> {
        return this.http.get<any>(`${this.workflowAPI}SavedSearchAnalytics/${savedSearchId}/PredictionModelMapping`);
    }

    getPredictionModelInference(savedSearchId: number, payload:any): Observable<any> {
        return this.http.post<any>(`${this.workflowAPI}SavedSearchAnalytics/${savedSearchId}/PredictionModelInference`, payload, {});
    }

    userInput(SaveUserInput) {
        return this.http.post<any>(`${this.workflowAPI}SavedSearchAnalytics/SaveUserInput`, SaveUserInput);
    }

}
